import { ValidationErrors } from '@angular/forms';

export function fiValidationHasErrors(validationErrors: ValidationErrors): boolean {
    if (!validationErrors) {
        return false;
    }
    for (let prop in validationErrors) {
        if (validationErrors[prop]) return true;
    }
    return false;
}
